import { VBtn } from 'vuetify/lib/components/VBtn';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VBtn,{staticClass:"font-weight-medium",attrs:{"color":_vm.color,"depressed":"","large":"","dark":"","loading":_vm.loading},on:{"click":_vm.exportCsv}},[_vm._v(" "+_vm._s(_vm.label)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }